import { Tag, Text, useDisclosure } from '@chakra-ui/core'
import LocaleText from 'components/LocaleText'
import AITaskCreationModal from 'components/TasksV2/AITaskCreation/AITaskCreationModal'
import React from 'react'
import { Sparkles } from 'lucide-react'
import { ActionButton, IconBlock } from './NavMenu'
import { useSelector } from 'react-redux'
import { RootState } from 'constants/interfaces'

export const CreateAITaskButton: React.FC<{ setIsHidden?: (hide: boolean) => void }> = ({ setIsHidden }) => {
  const { isOpen: isOpenCreateTask, onOpen: onOpenCreateTask, onClose: onCloseCreateTask } = useDisclosure()
  const theme = useSelector((state: RootState) => state.general.theme)

  const handleOpenModal = () => {
    setIsHidden?.(true)
    onOpenCreateTask()
  }

  const handleCloseModal = () => {
    setIsHidden?.(false)
    onCloseCreateTask()
  }

  return (
    <>
      <ActionButton onClick={handleOpenModal}>
        <IconBlock bg="#FAE2ED" borderRadius="10px" alignItems="center" justifyContent="center">
          <Sparkles size={18} color="#DD367E" />
        </IconBlock>
        <Text fontSize="14px">
          <LocaleText text="create_ai_vm_task_btn" />
        </Text>
        <Tag
          bg={theme?.elementsColor}
          color="white"
          borderRadius="20px"
          px="10px"
          py="2px"
          fontSize="10px"
          minH="unset"
          mx="10px"
        >
          <LocaleText text="Beta" />
        </Tag>
      </ActionButton>
      {isOpenCreateTask && <AITaskCreationModal isOpen={isOpenCreateTask} onClose={handleCloseModal} />}
    </>
  )
}
